<div id="ambulanceSearchForm">
  <div class="ambulance-search-form background-container-background">
    <div class="half-container">
      <div class="half-block half-container--tb-margin">
        <div
          class="flex-row-container"
          [ngClass]="{
            'error-box': searchParams.validationMessages?.includes(
              'Journey date/time cannot be in the past'
            )
          }"
        >
          <ngbd-datepicker-i18n>
            <div class="flex-column-container combo-box-left">
              <label
                class="header-label date-label"
                for="search-ambulance-pickup-date"
                i18n="@@meetingRoomSearchDate"
                >Date (DD/MM/YYYY)</label
              >
              <i class="ico-calendar combo-box-icon" aria-hidden="true" style="cursor: pointer"></i>
              <app-datepicker
                [minDate]="min_date"
                [startDate]="searchParams.date"
                [model]="searchParams.date"
                [class]="'combo-box'"
                [componentId]="'search-ambulance-pickup-date'"
                (newDate)="searchParams.date = $event"
              >
              </app-datepicker>
            </div>
            <div class="flex-column-container select-box-right">
              <label
                id="search-ambulance-pickup-time"
                class="header-label"
                i18n="@@ParkingSearchOutwardTime"
                for="ambulance_pickup-time"
                >Time</label
              >
              <i class="ico-clock combo-box-icon" aria-hidden="true"></i>
              <select appSelect id="ambulance_pickup-time" [(ngModel)]="searchParams.time">
                @for (time of timesArray; track time) {
                  <option [ngValue]="time">{{ time }}</option>
                }
              </select>
            </div>
          </ngbd-datepicker-i18n>
        </div>
      </div>
      <div class="half-block half-container--tb-margin">
        <div class="flex-row-container">
          <label
            id="ambulance-search-transport-type"
            class="header-label"
            for="ambulance_type"
            i18n="@@taxiSearchTransportType"
          >
            Transport type </label
          >:
        </div>
        <select
          appSelect
          [noIcon]="true"
          [(ngModel)]="searchParams.vehicleType"
          aria-labelledby="ambulance-search-transport-type"
          id="ambulance_type"
        >
          @for (transType of searchParams.transTypes; track transType; let i = $index) {
            <option [ngValue]="transType">
              <span id="transport-type-{{ i }}">{{ transType | translate }}</span>
            </option>
          }
        </select>
      </div>
    </div>
    <span i18n="@@required_hint"
      >Required mandatory fields are marked with an asterisk (*) and must be filled in to complete
      the form.</span
    >

    <div class="half-container half-container--start half-container--tb-margin">
      <div class="half-block">
        <span id="aria-ambulance-pickup-address" hidden i18n="@@AriaAmbulancePickupAddress"
          >Pickup address</span
        >
        <div
          [ngClass]="{
            'error-box': searchParams.validationMessages?.includes(
              'Pick up - Enter a location or postcode'
            )
          }"
        >
          <app-taxi-address-form
            [(address)]="searchParams.fromAddress"
            [(station)]="searchParams.fromStation"
            [required]="true"
            [modeType]="searchParams.mode"
            i18n-title
            title="Pick up"
            (addressChanged)="fromAddressChange($event)"
            (stationChange)="stationChange($event)"
            aria-labelledby="aria-ambulance-pickup-address"
          >
          </app-taxi-address-form>
        </div>
      </div>
      <div class="half-block">
        <span id="aria-ambulance-dropoff-address" hidden i18n="@@AriaAmbulanceDropoffAddress"
          >Dropoff address</span
        >
        <div
          [ngClass]="{
            'error-box': searchParams.validationMessages?.includes(
              'Drop off - Enter a location or postcode'
            )
          }"
        >
          <app-taxi-address-form
            [(address)]="searchParams.toAddress"
            [(station)]="searchParams.toStation"
            (addressChanged)="toAddressChange($event)"
            (stationChange)="stationChange($event, true)"
            [modeType]="searchParams.modeTo"
            [required]="true"
            i18n-title
            title="Drop off"
            aria-labelledby="aria-ambulance-dropoff-address"
          ></app-taxi-address-form>
        </div>
      </div>
    </div>
  </div>

  <div class="half-container">
    <div class="half-block">
      <div class="flex-row-container">
        <div
          class="flex-column-container phone-container"
          [ngClass]="{
            'error-box': searchParams.validationMessages?.includes('Please enter a phone number')
          }"
        >
          <label i18n="@@phoneNumberTitleCaps" for="ambulance-phone-number">Phone Number</label>
          <i class="ico-call-phone combo-box-icon" aria-hidden="true"></i>
          <div class="flex-row-container">
            <input
              placeholder="Enter a phone number"
              i18n-placeholder
              appInput
              [border]="true"
              id="ambulance-phone-number"
              [(ngModel)]="searchParams.phoneNumber"
            />
          </div>
        </div>
        @if (isDefaultExtension) {
          <div class="flex-column-container">
            <label i18n="@@phoneExtensionLabel" for="ambulance-phone-extension">Extension</label>
            <input
              appInput
              [noIcon]="true"
              [border]="true"
              id="ambulance-phone-extension"
              [(ngModel)]="searchParams.phoneExtension"
            />
          </div>
        }
      </div>
      <div class="half-block flex-column-container info-container">
        <label i18n="@@boltAdditionalInformation" for="ambulance-add-info" class="header-label"
          >Additional Information</label
        >
        <textarea
          class="textarea-container"
          rows="5"
          [(ngModel)]="searchParams.additionalInformation"
          id="ambulance-add-info"
          placeholder="Please provide any additional information about the patient or journey requirements..."
          i18n-placeholder
        >
        </textarea>
      </div>
    </div>
  </div>
</div>
